import React, { useEffect, useRef, useState } from 'react';
import './ScrollLayout.style.css';

const ScrollLayout = ({
  children,
  style = {},
  direction = 'vertical',
  scrollable = false,
  showScrollbar = false,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const scrollRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);

  /* ===== Hooks ===== */

  /* ===== Function ===== */
  /**
   * 스크롤 이벤트
   * --
   * @param {object} event
   * @returns
   */
  const handleScrollEvent = (event) => {
    if (!scrollable) return;

    // event.preventDefault();
    setIsScrolling(true);

    if (scrollRef.current) {
      switch (direction) {
        case 'horizontal':
          scrollRef.current.scrollLeft += event.deltaY;
          return;
        case 'vertical':
        default:
          scrollRef.current.scrollTop += event.deltaX;
          return;
      }
    }
  };

  /**
   * 페이지 스크롤 비활성화/활성화
   * --
   * @param {boolean} shouldPrevent
   */
  const preventPageScroll = (shouldPrevent) => {
    if (!scrollable) return;

    setMouseEnter(shouldPrevent);
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /**
   * 페이지 스크롤 방지 효과 적용
   * --
   */
  useEffect(() => {
    const preventDefault = (event) => event.preventDefault();

    if (mouseEnter) {
      window.addEventListener('wheel', preventDefault, { passive: false });
    } else {
      window.removeEventListener('wheel', preventDefault);
    }

    return () => {
      window.removeEventListener('wheel', preventDefault);
    };
  }, [mouseEnter]);

  /* ===== Render ===== */
  return (
    <div
      ref={scrollRef}
      className={`scroll_layout_wrapper ${direction} ${
        isScrolling ? 'scrolling' : ''
      } ${showScrollbar ? 'show_scrollbar' : ''} custom-scroll`}
      style={{ ...style }}
      onWheel={(e) => handleScrollEvent(e)}
      onMouseEnter={() => preventPageScroll(true)}
      onMouseLeave={() => preventPageScroll(false)}
    >
      {children}
    </div>
  );
};

export default ScrollLayout;
